import toast from "react-hot-toast";
import { getCategoryById, getCategories, getPackages, getInputById, getPackageById, getInputs, getUsers, getUserById, getOrders, getAds, getAdById, getAdByUserId, getCategoriesBlog, getCategoryBlogById, getBlogs, getBlogById, getNotifications, getNotificationsUnread, getPaymentMethod, getRoleById, getRoles, getOutComingNotifications, getEmployeeById, getEmployees, getOrdersExport, getAdsExport, getUsersExport, getReports, getReportsExport, getReportsByUserId, getPages, getPageById, getPagesSection, getPageSectionById, getBanners, getBannerById, getMarketingPromotions, getMarketingPromotionById, getStatistics, getRevenueByTime, getActiveAdsByTime, getVisitByHours, getUserByHours, getMe } from "./apiCalls";

export async function GetMe() {
    try {
        const response = await getMe();
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetHomeData(params) {
    try {
        const response = await getStatistics(params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetRevenueByTimeData(params) {
    try {
        const response = await getRevenueByTime(params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};
export async function GetActiveAdsByTimeData(params) {
    try {
        const response = await getActiveAdsByTime(params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};
export async function GetVisitByHoursData(params) {
    try {
        const response = await getVisitByHours(params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};
export async function GetUserByHoursData(params) {
    try {
        const response = await getUserByHours(params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

//////////////////////////////Categories///////////////////////////////////

export async function GetCategoriesData(currentPage, params) {
    try {
        const response = await getCategories(currentPage, params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetCategoriesByIdData(id) {
    try {
        const response = await getCategoryById(id);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

////////////////////////Inputs//////////////////////////

export async function GetInputsData(currentPage, params) {
    try {
        const response = await getInputs(currentPage, params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetInputsByIdData(id) {
    try {
        const response = await getInputById(id);
        return response.data.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

////////////////////////Packages//////////////////////////

export async function GetPackagesData(currentPage, params) {
    try {
        const response = await getPackages(currentPage, params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetPackagesByIdData(id) {
    try {
        const response = await getPackageById(id);
        return response.data.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

////////////////////////Users//////////////////////////

export async function GetUsersData(currentPage, params) {
    try {
        const response = await getUsers(currentPage, params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetUsersExportData(perPage, params) {
    try {
        const response = await getUsersExport(perPage, params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetUserByIdData(id) {
    try {
        const response = await getUserById(id);
        return response.data.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

////////////////////////Orders//////////////////////////

export async function GetOrdersData(currentPage, params) {
    try {
        const response = await getOrders(currentPage, params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetOrdersExportData(perPage, params) {
    try {
        const response = await getOrdersExport(perPage, params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

////////////////////////Ads//////////////////////////

export async function GetAdsData(currentPage, params) {
    try {
        const response = await getAds(currentPage, params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetAdsExportData(perPage, params) {
    try {
        const response = await getAdsExport(perPage, params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetAdByIdData(id) {
    try {
        const response = await getAdById(id);
        return response.data.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetAdByUserIdData(id, currentPage, params) {
    try {
        const response = await getAdByUserId(id, currentPage, params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

////////////////////////Categories of Blogs//////////////////////////

export async function GetCategoriesBlogData(currentPage, params) {
    try {
        const response = await getCategoriesBlog(currentPage, params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetCategoryBlogByIdData(id) {
    try {
        const response = await getCategoryBlogById(id);
        return response.data.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

////////////////////////Blogs//////////////////////////

export async function GetBlogData(currentPage, params) {
    try {
        const response = await getBlogs(currentPage, params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetBlogByIdData(id) {
    try {
        const response = await getBlogById(id);
        return response.data.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

////////////////////////Notifications///////////////////////////////

export async function GetNotificationsData(currentPage, params) {
    try {
        const response = await getNotifications(currentPage, params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetOutComingNotificationsData(currentPage, params) {
    try {
        const response = await getOutComingNotifications(currentPage, params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetNotificationsUnreadData(currentPage, params) {
    try {
        const response = await getNotificationsUnread(currentPage, params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

////////////////////////Payment Method////////////////////////////////

export async function GetPaymentMethodData() {
    try {
        const response = await getPaymentMethod();
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

///////////////////////////Roles//////////////////////////////////////////

export async function GetRoles(currentPage) {

    try {
        const response = await getRoles(currentPage);
        return response.data.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetRolesById(id) {
    try {
        const response = await getRoleById(id);
        return response.data.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

///////////////////////////Employees//////////////////////////////////////////

export async function GetEmployeesData(currentPage) {

    try {
        const response = await getEmployees(currentPage);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetEmployeesByIdData(id) {
    try {
        const response = await getEmployeeById(id);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

///////////////////////////Reports//////////////////////////////////////////

export async function GetReportsData(currentPage) {

    try {
        const response = await getReports(currentPage);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetReportsExportData(perPage, params) {
    try {
        const response = await getReportsExport(perPage, params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetReportsByUserIdData(id, currentPage, params) {
    try {
        const response = await getReportsByUserId(id, currentPage, params);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

///////////////////////////////////////Pages Cruds///////////////////////////////////////

export async function GetPagesData(currentPage) {

    try {
        const response = await getPages(currentPage);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetPageByIdData(id) {
    try {
        const response = await getPageById(id);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

///////////////////////////////////////Pages Section Cruds///////////////////////////////////////

export async function GetPagesSectionData(currentPage) {

    try {
        const response = await getPagesSection(currentPage);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetPageSectionByIdData(id) {
    try {
        const response = await getPageSectionById(id);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

///////////////////////////////////////Banner Cruds///////////////////////////////////////

export async function GetBannersData(currentPage) {

    try {
        const response = await getBanners(currentPage);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetBannerByIdData(id) {
    try {
        const response = await getBannerById(id);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

///////////////////////////////////////Marketing Promotions Cruds///////////////////////////////////////

export async function GetMarketingPromotionsData(currentPage) {

    try {
        const response = await getMarketingPromotions(currentPage);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function GetMarketingPromotionByIdData(id) {
    try {
        const response = await getMarketingPromotionById(id);
        return response.data;
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التحميل . يرجى المحاولة مرة أخرى");
        return null;
    };
};